import type { AxiosError } from 'axios'

export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null
  try {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
    if (!match) return null
    const encoded = match.substring('XSRF-TOKEN='.length)
    return decodeURIComponent(encoded)
  } catch {
    return null
  }
}

/**
 * Extracts a flat array of validation error strings from a Laravel 422 response.
 * Returns an empty array for any other error shape.
 */
export function extractValidationErrors(e: unknown): string[] {
  const err = e as AxiosError<{ errors?: Record<string, string[]> }>
  const errors = err?.response?.data?.errors
  if (!errors) return []
  return Object.values(errors).flat()
}
